"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgLite = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var supports_webp_sync_1 = require("supports-webp-sync");
var thumbnail_1 = require("../../utils/thumbnail");
var ImgLite_styles_1 = require("./ImgLite.styles");
var ImgLite_types_1 = require("./ImgLite.types");
var IS_SERVER_SIDE = globalThis.document === undefined;
var SIGNIFICANT_SIZE_CHANGE = 0.1;
var SUPPORTS_WEBP = Boolean(globalThis.document && (0, supports_webp_sync_1.checkWebPSupport)());
var useIsomorphicLayoutEffect = IS_SERVER_SIDE ? react_1.useEffect : react_1.useLayoutEffect;
var getDevicePixelRation = function () {
    return globalThis.devicePixelRatio || 1;
};
var shouldUpdateDimensions = function (_a) {
    var currentHeight = _a.currentHeight, currentWidth = _a.currentWidth, nextHeight = _a.nextHeight, nextWidth = _a.nextWidth, rule = _a.rule;
    if (!currentWidth || !currentHeight)
        return true;
    var didChangeSignificantly = Math.abs(nextWidth - currentWidth) / currentWidth > SIGNIFICANT_SIZE_CHANGE ||
        Math.abs(nextHeight - currentHeight) / currentHeight > SIGNIFICANT_SIZE_CHANGE;
    if (!didChangeSignificantly)
        return false;
    switch (rule) {
        case ImgLite_types_1.UpdateDimensionsRule.Always:
            return true;
        case ImgLite_types_1.UpdateDimensionsRule.OnlyOnGrowth:
            return nextWidth > currentWidth || nextHeight > currentHeight;
    }
};
var _ImgLite = function (_a, ref) {
    var _b = _a.avif, avif = _b === void 0 ? false : _b, children = _a.children, _c = _a.density, density = _c === void 0 ? getDevicePixelRation() : _c, fit = _a.fit, gravity = _a.gravity, height = _a.height, _d = _a.isPrintable, isPrintable = _d === void 0 ? false : _d, onError = _a.onError, onLoad = _a.onLoad, _e = _a.priority, priority = _e === void 0 ? false : _e, pulseBackground = _a.pulseBackground, quality = _a.quality, sharpen = _a.sharpen, src = _a.src, _f = _a.updateDimensionsRule, updateDimensionsRule = _f === void 0 ? ImgLite_types_1.UpdateDimensionsRule.OnlyOnGrowth : _f, width = _a.width, otherProps = __rest(_a, ["avif", "children", "density", "fit", "gravity", "height", "isPrintable", "onError", "onLoad", "priority", "pulseBackground", "quality", "sharpen", "src", "updateDimensionsRule", "width"]);
    var imageRef = (0, react_1.useMemo)(function () {
        if (ref && typeof ref === 'function') {
            throw new Error('You cannot use ref functions with ImgLite');
        }
        return (ref || (0, react_1.createRef)());
    }, [ref]);
    var _g = (0, react_1.useState)(''), liteSrc = _g[0], setLiteSrc = _g[1];
    var _h = (0, react_1.useState)(priority), isVisible = _h[0], setVisible = _h[1];
    var _j = (0, react_1.useState)(0), measuredWidth = _j[0], setMeasuredWidth = _j[1];
    var _k = (0, react_1.useState)(0), measuredHeight = _k[0], setMeasuredHeight = _k[1];
    var updateDimensionsRef = (0, react_1.useRef)(null);
    updateDimensionsRef.current = function () {
        var imageElement = imageRef.current;
        if (!imageElement)
            return;
        var newWidth = imageElement.offsetWidth;
        var newHeight = imageElement.offsetHeight;
        if (!IS_SERVER_SIDE && isVisible && (newHeight === 0 || newWidth === 0)) {
            console.error('[ImgLite] The following image container should have positive height and width:', imageElement);
        }
        var shouldUpdate = shouldUpdateDimensions({
            currentHeight: measuredHeight,
            currentWidth: measuredWidth,
            nextHeight: newHeight,
            nextWidth: newWidth,
            rule: updateDimensionsRule,
        });
        if (shouldUpdate) {
            setMeasuredWidth(newWidth);
            setMeasuredHeight(newHeight);
        }
    };
    var updateLiteSrc = (0, react_1.useCallback)(function (_a) {
        var width = _a.width, height = _a.height;
        var newLiteSrc = (0, thumbnail_1.thumbnail)(src, {
            height: height,
            width: width,
            density: density,
            fit: fit,
            gravity: gravity,
            quality: quality,
            sharpen: sharpen,
            avif: avif,
            webp: SUPPORTS_WEBP,
        });
        if (!liteSrc) {
            setLiteSrc(newLiteSrc);
        }
        else {
            var newImg = new Image();
            newImg.src = newLiteSrc;
            newImg.addEventListener('load', function () {
                setLiteSrc(newLiteSrc);
            });
        }
    }, [src, density, fit, gravity, quality, sharpen, liteSrc]);
    var uniqueId = (0, ImgLite_styles_1.useImgLiteStyles)({
        isPrintable: isPrintable,
        liteSrc: liteSrc,
        width: width,
        height: height,
        pulseBackground: pulseBackground,
        children: children,
    });
    useIsomorphicLayoutEffect(function () {
        var _a;
        var resizeObserver = new ResizeObserver((0, lodash_1.debounce)(function () { var _a; return (_a = updateDimensionsRef.current) === null || _a === void 0 ? void 0 : _a.call(updateDimensionsRef); }, 100));
        resizeObserver.observe(imageRef.current);
        (_a = updateDimensionsRef.current) === null || _a === void 0 ? void 0 : _a.call(updateDimensionsRef);
        return function () {
            resizeObserver.disconnect();
        };
    }, [imageRef, updateDimensionsRef]);
    (0, react_1.useEffect)(function () {
        if (measuredWidth && measuredHeight && isVisible) {
            updateLiteSrc({
                width: measuredWidth,
                height: measuredHeight,
            });
        }
    }, [measuredHeight, measuredWidth, updateLiteSrc, isVisible]);
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = imageRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute('data-imglite-id', uniqueId);
    }, [uniqueId, imageRef]);
    useIsomorphicLayoutEffect(function () {
        var _a;
        var intersectionObserver;
        if ('IntersectionObserver' in globalThis && imageRef.current) {
            intersectionObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var imgLiteElement = entry.target;
                        imgLiteElement.setAttribute('data-imglite-visible', 'true');
                        setVisible(true);
                        intersectionObserver.unobserve(imgLiteElement);
                    }
                });
            });
            intersectionObserver.observe(imageRef.current);
        }
        else if (imageRef.current) {
            (_a = imageRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute('data-imglite-visible', 'true');
            setVisible(true);
        }
        return function () {
            intersectionObserver.disconnect();
        };
    }, []);
    if (IS_SERVER_SIDE && !liteSrc && Number.isFinite(height) && Number.isFinite(width)) {
        updateLiteSrc({
            height: height,
            width: width,
        });
    }
    return (react_1.default.createElement("div", __assign({ ref: imageRef, "data-imglite-id": uniqueId, "data-imglite-visible": String(isVisible) }, (IS_SERVER_SIDE ? { style: { width: width, height: height } } : {}), otherProps, { suppressHydrationWarning: true }), children));
};
exports.ImgLite = (0, react_1.forwardRef)(_ImgLite);
